import { Component } from '@angular/core';
import { TranslateModule } from '@client/app/modules/translate.module';

@Component({
    selector: 'seo-too-many-page-links',
    templateUrl: './too-many-page-links.component.html',
    standalone: true,
    imports: [TranslateModule],
})
export class SeoTooManyPageLinksComponent {
}
